import React, {Component} from 'react'
import PropTypes from 'prop-types';
import {Link} from "react-router-dom";

export default class ResultItem extends Component
{
    static propTypes = {
        name: PropTypes.string,
        link: PropTypes.string,
        displayName: PropTypes.string,
        clickHandler: PropTypes.func
    };
    render() {
        const {name, link, displayName} = this.props;

        const shortName = (name.split(':').length > 1) ? name.split(':')[1].replaceAll('/', '/&#8203;') : name;

        return (
            <tr key={name}>
                <td><Link to={'/show/' + link} onClick={() => this.props.clickHandler()}>
                    {name?(
                        <div>
                            <div><b>{displayName}</b></div>
                            <small dangerouslySetInnerHTML={{__html: shortName}} />
                        </div>
                    ): displayName}
                </Link></td>
            </tr>
        );
    }
}



// WEBPACK FOOTER //
// ./React/src/components/LabelSearch/ResultItem.js